
import React from 'react';
import { AIStaffMember } from '@/lib/types';
import AIStaffCard from '@/components/dashboard/AIStaffCard';
import { Card, CardContent } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

interface CurrentStaffListProps {
  isLoading: boolean;
  allAIStaff: AIStaffMember[];
}

const CurrentStaffList: React.FC<CurrentStaffListProps> = ({ isLoading, allAIStaff }) => {
  const navigate = useNavigate();
  
  const handleStaffClick = (staffId: string) => {
    navigate(`/app/staff/${staffId}`);
  };
  
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2].map((i) => (
          <Card key={i} className="h-[300px] animate-pulse bg-muted/50"></Card>
        ))}
      </div>
    );
  }
  
  // Filter to only show active staff members
  const activeStaff = allAIStaff.filter(staff => 
    !staff.hasOwnProperty('is_active') || staff.is_active
  );
  
  if (activeStaff.length === 0) {
    return (
      <Card className="p-6 text-center mb-6">
        <CardContent className="pt-6">
          <p>You haven't hired any AI staff members yet.</p>
          <p className="text-muted-foreground mt-2">Choose from the available assistants below to get started.</p>
        </CardContent>
      </Card>
    );
  }
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {activeStaff.map((staff) => (
        <AIStaffCard 
          key={staff.id} 
          staff={staff} 
          onClick={() => handleStaffClick(staff.id)} 
        />
      ))}
    </div>
  );
};

export default CurrentStaffList;
